'use client';

import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { NavPill } from '@/components/ui/nav-pill';
import { MOBILE_TAB_ITEMS as ITEMS } from './mobile-tabs';
import styles from './mobile-action-bar.module.css';

// The tab items + MOBILE_TAB_HREFS live in the server-safe ./mobile-tabs module
// so the Server Component Header can import the href list without it degrading
// to a client-reference proxy (which lost its array methods and crashed render).

/**
 * Mobile bottom action bar — 4 primary tabs, composed from the shared NavPill
 * (orientation `tab`: stacked icon over label, active = accent, no fill).
 */
export function MobileActionBar() {
  const pathname = usePathname();
  const t = useTranslations('nav');

  return (
    <nav className={styles.bar} aria-label={t('mobileNavigation')}>
      {ITEMS.map(({ href, labelKey, icon }) => {
        const active = pathname === href || pathname.startsWith(`${href}/`);
        return (
          <NavPill
            key={href}
            href={href}
            orientation="tab"
            icon={icon}
            active={active}
            className={styles.tab}
          >
            {t(labelKey)}
          </NavPill>
        );
      })}
    </nav>
  );
}
